
<!--
  ~ Copyright ou © ou Copr. Université de Lorraine, (2022)
  ~
  ~ Direction du Numérique de l'Université de Lorraine - SIED
  ~  (dn-mobile-dev@univ-lorraine.fr)
  ~ JNESIS (contact@jnesis.com)
  ~
  ~ Ce logiciel est un programme informatique servant à rendre accessible
  ~ sur mobile divers services universitaires aux étudiants et aux personnels
  ~ de l'université.
  ~
  ~ Ce logiciel est régi par la licence CeCILL 2.1, soumise au droit français
  ~ et respectant les principes de diffusion des logiciels libres. Vous pouvez
  ~ utiliser, modifier et/ou redistribuer ce programme sous les conditions
  ~ de la licence CeCILL telle que diffusée par le CEA, le CNRS et INRIA
  ~ sur le site "http://cecill.info".
  ~
  ~ En contrepartie de l'accessibilité au code source et des droits de copie,
  ~ de modification et de redistribution accordés par cette licence, il n'est
  ~ offert aux utilisateurs qu'une garantie limitée. Pour les mêmes raisons,
  ~ seule une responsabilité restreinte pèse sur l'auteur du programme, le
  ~ titulaire des droits patrimoniaux et les concédants successifs.
  ~
  ~ À cet égard, l'attention de l'utilisateur est attirée sur les risques
  ~ associés au chargement, à l'utilisation, à la modification et/ou au
  ~ développement et à la reproduction du logiciel par l'utilisateur étant
  ~ donné sa spécificité de logiciel libre, qui peut le rendre complexe à
  ~ manipuler et qui le réserve donc à des développeurs et des professionnels
  ~ avertis possédant des connaissances informatiques approfondies. Les
  ~ utilisateurs sont donc invités à charger et à tester l'adéquation du
  ~ logiciel à leurs besoins dans des conditions permettant d'assurer la
  ~ sécurité de leurs systèmes et/ou de leurs données et, plus généralement,
  ~ à l'utiliser et à l'exploiter dans les mêmes conditions de sécurité.
  ~
  ~ Le fait que vous puissiez accéder à cet en-tête signifie que vous avez
  ~ pris connaissance de la licence CeCILL 2.1, et que vous en avez accepté les
  ~ termes.
  -->

<ion-content id="scrollContent" *ngIf="(featuresIsEmpty$ | async) === false && (menuItems$ | async)"
[scrollEvents]="true"
(ionScrollStart)="handleScrollStart()">
  <ion-row data-service-id="searchbar" class="searchbar-row">
    <ion-searchbar show-clear-button="focus" [placeholder]="'FEATURES.SEARCHBAR_MESSAGE' | translate"
                   [attr.aria-label]="'FEATURES.SEARCHBAR_MESSAGE' | translate" (ionChange)="handleChange($event)"
                   [disabled]="draggableIsOn" class="safe-area-margin-lr"></ion-searchbar>
  </ion-row>

  <ion-fab *ngIf="draggableIsOn" slot="fixed" vertical="bottom" horizontal="end">
    <ion-fab-button size="small" (click)="deactivateDrag()" [attr.aria-label]="'FEATURES.DRAG_DEACTIVATION' | translate">
      <ion-icon name="checkmark-circle-outline" aria-label=""></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <div #servicesContainer class="container-draggable-list" dragula="SERVICES" [(dragulaModel)]="menuItems">

    <div #draggableServices class="not-draggable draggable-container" *ngFor="let menuItem of menuItems;">
      <div class="inner-draggable-container">
        <ion-button shape="round" size="small" *ngIf="draggableIsOn"
          class="drag-button ion-no-padding ion-no-margin" dragHandle>
          <ion-icon class="drag-button-icon" name="move-outline" dragHandle slot="icon-only"
            size="small" aria-label=""></ion-icon>
        </ion-button>

        <ion-badge class="new app-title-7" *ngIf="menuItem.isNew">{{ "FEATURES.NEW" | translate }}</ion-badge>

        <app-service [menuItem]="menuItem" [draggableIsOn]="draggableIsOn"></app-service>
      </div>
    </div>
  </div>

</ion-content>

<ion-content class="ion-padding" *ngIf="(featuresIsEmpty$ | async)">
  <ion-note> {{ "FEATURES.NO_DATA" | translate }} </ion-note>
</ion-content>
